
__webpack_require__.remotesLoadingData = { chunkMapping: {"663":["2645"]}, moduleIdToRemoteDataMapping: {"2645":{"shareScope":"default","name":"./api/client","externalModuleId":9759,"remoteName":"shared"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
